// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7794b663","239":"0ca1bac1","455":"e278e8bb"}[chunkId] + ".chunk.js";
};